import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ShareLibraryItemDialogComponent } from './share-library-item-dialog.component';
import { FocusOnFirstInvalidFieldModule } from '@go-modules/directives/focus-on-first-invalid-field';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		FocusOnFirstInvalidFieldModule
	],
	declarations: [
		ShareLibraryItemDialogComponent
	],
	exports: [
		ShareLibraryItemDialogComponent
	]
})
export class ShareLibraryItemDialogModule {}
